import ContactButton from "components/molecules/ContactButton"
import SectionContainer from "components/molecules/common/SectionContainer"
import {
  AdjustmentsVerticalIcon,
  VideoCameraIcon,
  ComputerDesktopIcon,
  CheckBadgeIcon,
} from "@heroicons/react/24/outline"
import useTranslations from "hooks/useTranslations"

const Box = ({ point }) => {
  return (
    <div className="flex items-start space-x-3 space-y-3">
      <div className="w-6 shrink-0 pt-3 text-kkm-green">
        <point.icon />
      </div>
      <div className="text-zinc-300">
        <div className="inline font-bold ">{point.title}</div>
        <div className="inline ">{point.description}</div>
      </div>
    </div>
  )
}

const Solution = ({ name, description = "", includedFeatures = [] }) => {
  const { proCoursesSolutionsIncluded } = useTranslations()

  return (
    <div
      key={name}
      className="divide-y divide-zinc-200 overflow-hidden rounded-lg border border-zinc-200 bg-white"
    >
      <div className="space-y-4 bg-zinc-50 p-6 pb-4">
        <h2 className="m-0 rounded-t-lg font-display text-xl leading-7 tracking-normal text-zinc-900 lg:whitespace-pre-line xl:text-2xl">
          {name}
        </h2>
        {description && (
          <p className="mt-4 text-sm text-zinc-500">{description}</p>
        )}
      </div>
      <div className="p-6">
        <h3 className="m-0 text-xs font-medium uppercase tracking-wide text-zinc-900">
          {proCoursesSolutionsIncluded}
        </h3>
        <ul role="list" className="mt-4 space-y-4">
          {includedFeatures.map((feature) => (
            <div className="flex items-start">
              <CheckBadgeIcon className="w-6 shrink-0 pt-0.5" />
              <li className="prose m-0 list-none pl-2 text-sm text-zinc-800">
                {feature}
              </li>
            </div>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default () => {
  const {
    proCoursesSolutionsHeading,
    proCoursesSolutionsSubheading,
    proCoursesSolutions1Segment,
    proCoursesSolutions1Name,
    proCoursesSolutions1Features,
    proCoursesSolutions1Effects,
    proCoursesSolutions2Segment,
    proCoursesSolutions2Name,
    proCoursesSolutions2Features,
    proCoursesSolutions2Effects,
    proCoursesSolutions3Segment,
    proCoursesSolutions3Name,
    proCoursesSolutions3Features,
    proCoursesSolutions3Effects,
    proCoursesSolutionsPoint1Title,
    proCoursesSolutionsPoint1Description,
    proCoursesSolutionsPoint2Title,
    proCoursesSolutionsPoint2Description,
    proCoursesSolutionsPoint3Title,
    proCoursesSolutionsPoint3Description,
  } = useTranslations()

  const solutions = [
    {
      segment: proCoursesSolutions1Segment,
      name: proCoursesSolutions1Name,
      includedFeatures: proCoursesSolutions1Features,
      effects: proCoursesSolutions1Effects,
    },
    {
      segment: proCoursesSolutions2Segment,
      name: proCoursesSolutions2Name,
      includedFeatures: proCoursesSolutions2Features,
      effects: proCoursesSolutions2Effects,
    },
    {
      segment: proCoursesSolutions3Segment,
      name: proCoursesSolutions3Name,
      includedFeatures: proCoursesSolutions3Features,
      effects: proCoursesSolutions3Effects,
    },
  ]
  const list = [
    {
      title: proCoursesSolutionsPoint1Title,
      icon: AdjustmentsVerticalIcon,
      description: proCoursesSolutionsPoint1Description,
    },
    {
      title: proCoursesSolutionsPoint2Title,
      icon: VideoCameraIcon,
      description: proCoursesSolutionsPoint2Description,
    },
    {
      title: proCoursesSolutionsPoint3Title,
      icon: ComputerDesktopIcon,
      description: proCoursesSolutionsPoint3Description,
    },
  ]
  return (
    <SectionContainer
      className="bg-zinc-800 text-kkm-darkgreen"
      title={proCoursesSolutionsHeading}
      description={proCoursesSolutionsSubheading}
      descriptionTextColor="text-zinc-100"
    >
      <div className="flex flex-col space-y-10">
        <div className="mt-10 space-y-4 sm:mt-12 sm:grid sm:grid-cols-1 sm:gap-6 sm:space-y-0 lg:mx-auto lg:grid-cols-3 xl:mx-0 xl:max-w-none">
          {solutions.map((solution) => (
            <Solution {...solution} />
          ))}
        </div>
        {Array.isArray(list) && (
          <div className="order-last gap-6 md:flex lg:order-none">
            {list.map((point) => (
              <Box point={point} />
            ))}
          </div>
        )}
        <div className="mx-auto w-full">
          <ContactButton bgStyle="green" />
        </div>
      </div>
    </SectionContainer>
  )
}
